export function baseurl() {
    // return "https://ticket.siadat.net/api_tiket/";
    return (window.location.host === 'ticket.siadat.net') ? "https://ticket.siadat.net/api_tiket/"  : window.location.origin.replace(":8081", ":8080")+"/api_tiket/";
}
export function imgurl() {
    return (window.location.host === 'ticket.siadat.net') ? "https://ticket.siadat.net/api_tiket/upload/"  : window.location.origin.replace(":8081", ":8080")+"/api_tiket/upload/";
}
export function upldurl() {
    return (window.location.host === 'ticket.siadat.net') ? "https://ticket.siadat.net/api_tiket/ajaxfile.php"  : window.location.origin.replace(":8081", ":8080")+"/api_tiket/ajaxfile.php";
}
export function sendSms() {
    return (window.location.host === 'ticket.siadat.net') ? "https://ticket.siadat.net/api_tiket/sendSms.php"  : window.location.origin.replace(":8081", ":8080")+"/api_tiket/sendSms.php";
}
export function sendSms_mould() {
    return (window.location.host === 'ticket.siadat.net') ? "https://ticket.siadat.net/api_tiket/sendSms_mould.php"  : window.location.origin.replace(":8081", ":8080")+"/api_tiket/sendSms_mould.php";
}